<template>
  <div class="page-main">
    <div class="flex flex-y-center flex-x-between m-b-10">
          <div class="flex flex-y-center">
            <el-button type="success" size="mini" icon="el-icon-plus" @click="itemDo()"
              >新增送货单
            </el-button>
            <el-dropdown class="m-l-10">
              <el-button type="default" size="mini">
                批量操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item @click.native="batchPass">
                  <span class="c-green">审核</span>
                </el-dropdown-item>
                <el-dropdown-item @click.native="batchReject">
                  <span class="c-blue">反审核</span>
                </el-dropdown-item> -->
                <el-dropdown-item @click.native="batchDelete">
                  <span class="c-red">删除</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-form class="flex flex-y-center m-l-10" @submit.native.prevent="searchListData">
              <span>发货日期:</span>
              <e-date-picker
                type="daterange"
                :value.sync="delivery_date"
                isShowFast
                @change="searchListData"
              />
            </el-form>
            <!-- 一键清空所有表头筛选 -->
            <el-button
              size="mini"
              icon="el-icon-refresh"
              class="m-l-10"
              :disabled="!hasFilter"
              @click="resetFilter"
              >重置筛选
            </el-button>
          </div>
        </div>
        <!-- 表格 -->
        <vxe-grid
          ref="refTable"
          :show-footer="!!tableData.length"
          :loading="loading"
          :columns="tableColumn"
          :data="tableData"
          :height="this.$util.getViewHeight() - 36 - 148"
          :footer-method="footerMethod"
          :cell-class-name="cellClassName"
          @cell-dblclick="itemDbDo"
          @resizable-change="handleColumnResize"
          @keydown="tableKeydown"
          @current-change="tableCurrentChange"
        >
          <!-- slot_header 表头筛选 -->
          <template #header_input="{ column }">
            <c-table-header
              :title="column.title"
              :field="column.field"
              :url="headerFilterUrl"
              :filterData="filterData"
              :value="filterData[column.field]"
              placeholder="输入关键字"
              @change="headerFilterChange"
            />
          </template>
          <!-- 是否已打印-表头筛选 -->
          <template #header_is_print="{ column }">
            <div class="header-filter-box">
              <div>{{ column.title }}</div>
              <el-select
                v-model="filterData.is_print"
                size="mini"
                placeholder="全部"
                clearable
                style="width: 80px"
                @change="searchListData"
              >
                <el-option label="已打印" value="1" />
                <el-option label="未打印" value="0" />
              </el-select>
            </div>
          </template>
          <!-- slot_default -->
          <template #default_delivery_code="{ row }">
            <el-link type="primary" @click="itemDo(row.delivery_id)">
              {{ row.delivery_code }}
            </el-link>
          </template>
          <template #default_delivery_status="{ row }">
            <el-tag :type="statusTagType(row)" size="mini" plain>{{ row.status_str }}</el-tag>
          </template>
          <template #default_delivery_date="{ row }">
            {{ row.delivery_date_str || (row.delivery_date ? row.delivery_date.slice(0, 10) : '') }}
          </template>
          <template #default_create_date="{ row }">
            {{ row.create_date_str || (row.create_date ? row.create_date.slice(0, 10) : '') }}
          </template>
          <template #default_saler_name="{ row }">
            <div>{{ row.saler_name }}</div>
            <div v-if="row.shen_qing_bu_men_name" class="c-gray">
              ({{ row.shen_qing_bu_men_name }})
            </div>
          </template>
          <template #default_song_huo_total="{ row }">
            <span class="c-orange">{{ row.song_huo_total }}</span>
          </template>
          <!-- 是否已打印-显示 -->
          <template #default_is_print="{ row }">
            <el-tag v-if="row.is_print" type="success" size="mini">已打印</el-tag>
            <el-tag v-else type="danger" size="mini">未打印</el-tag>
          </template>
          <template #default_operate="{ row }">
            <el-dropdown>
              <el-button type="default" size="mini">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="canEdit(row)" @click.native="itemDo(row.delivery_id)">
                  <span class="c-blue">编辑</span>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="canAudit(row) && $tool.hasControl(['/songHuo4/changeStatus'])"
                  @click.native="itemPass(row)"
                >
                  <span class="c-green">审核</span>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="canUnaudit(row) && $tool.hasControl(['/songHuo4/changeStatus'])"
                  @click.native="itemReject(row)"
                >
                  <span class="c-blue">反审核</span>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="canAudit(row) && $tool.hasControl(['/songHuo4/cancel'])"
                  @click.native="itemCancel(row)"
                >
                  <span class="c-gray">作废</span>
                </el-dropdown-item>
                <el-dropdown-item @click.native="itemPrint(row.delivery_id)">
                  <span class="c-gray">打印</span>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="isAdmin && canEdit(row)"
                  @click.native="itemDelete({ ids: [row.delivery_id], codes: [row.delivery_code] })"
                >
                  <span class="c-red">删除</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>

          <!-- slot_pager -->
          <template #pager>
            <div></div>
            <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
          </template>
        </vxe-grid>

    <!-- 弹窗-新增送货单 -->
    <PopupDo
      v-if="isShowPopupDo"
      :show.sync="isShowPopupDo"
      :detailId="activeId"
      :isAdmin="isAdmin"
      @success="updatePage"
    />
  </div>
</template>

<script>
export default {
  tableName: 'new_delivery_page_list',
  components: {
    PopupDo: () => import('../common/popup-do')
  },
  data() {
    return {
      // loading
      loading: true,

      // filter（是否已打印已下沉到表头筛选，保留在 filterData 中）
      delivery_date: [],
      filterData: {
        delivery_code: '',
        bill_code: '',
        customer_name: '',
        delivery_date_str: '',
        saler_name: '',
        gong_cheng_fu_ze_ren_name: '',
        pmc_fu_ze_ren_name: '',
        bu_men_name: '',
        goods_name: '',
        goods_spec: '',
        goods_unit: '',
        song_huo_count: '',
        goods_price: '',
        song_huo_amount: '',
        song_huo_total: '',
        goods_remark: '',
        remark: '',
        saler_company_name: '',
        is_print: '',
        create_date_str: ''
      },
      sortData: {
        create_date: 'desc'
      },

      // table
      tableData: [],
      pageOptions: {
        ...this.$constant.page
      },
      totalObj: {
        goods_count_all: '',
        goods_price_all: '',
        goods_amount_all: '',
        song_huo_total_all: ''
      },

      // popup
      isShowPopupDo: false,
      activeBillId: null,
      activeId: null
    }
  },
  computed: {
    // 是否存在已生效的表头筛选条件
    hasFilter() {
      let result = Object.keys(this.filterData).some((key) => {
        let val = this.filterData[key]
        return val !== '' && val !== null && val !== undefined
      })
      return result
    },
    // 是否是管理员
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    },
    // 当前登录账号id
    accountId() {
      return this.$store.state.loginAccount.id
    },
    // 表头联想筛选接口
    headerFilterUrl() {
      return '/admin/gcvip/songHuo4/searchHeard'
    },
    // 表格列
    tableColumn() {
      let result = [
        {
          fixed: 'left',
          type: 'checkbox',
          width: 40
        },
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          fixed: 'left',
          title: '送货单号',
          field: 'delivery_code',
          slots: { header: 'header_input', default: 'default_delivery_code' },
          width: 110
        },
        {
          title: '销售单号',
          field: 'bill_code',
          slots: { header: 'header_input' }
        },
        {
          title: '审核状态',
          field: 'delivery_status',
          slots: { default: 'default_delivery_status' }
        },
        {
          title: '工程负责人',
          field: 'gong_cheng_fu_ze_ren_name',
          width: 100,
          slots: { header: 'header_input' }
        },
        {
          title: 'PMC负责人',
          field: 'pmc_fu_ze_ren_name',
          width: 100,
          slots: { header: 'header_input' }
        },
        {
          title: '客户',
          field: 'customer_name',
          slots: { header: 'header_input' }
        },
        {
          title: '发货日期',
          field: 'delivery_date_str',
          slots: { header: 'header_input', default: 'default_delivery_date' }
        },
        {
          title: '创建日期',
          field: 'create_date_str',
          slots: { header: 'header_input', default: 'default_create_date' }
        },
        {
          title: '制单人',
          field: 'saler_name',
          slots: { header: 'header_input', default: 'default_saler_name' }
        },
        {
          title: '部门',
          field: 'bu_men_name',
          slots: { header: 'header_input' }
        },
        {
          title: '品名',
          field: 'goods_name',
          slots: { header: 'header_input' }
        },
        {
          title: '规格(mm)',
          field: 'goods_spec',
          width: 120,
          slots: { header: 'header_input' }
        },
        {
          title: '单位',
          field: 'goods_unit',
          slots: { header: 'header_input' }
        },
        {
          title: '送货数量',
          field: 'song_huo_count',
          slots: { header: 'header_input' }
        },
        {
          title: '单价(元)',
          field: 'goods_price',
          slots: { header: 'header_input' }
        },
        {
          title: '送货金额(元)',
          field: 'song_huo_amount',
          slots: { header: 'header_input' }
        },
        {
          title: '送货单金额(元)',
          field: 'song_huo_total',
          slots: { header: 'header_input', default: 'default_song_huo_total' },
          width: 100
        },
        {
          title: `备注`,
          field: 'goods_remark',
          width: 160,
          slots: { header: 'header_input' }
        },
        {
          title: `单据备注`,
          field: 'remark',
          width: 160,
          slots: { header: 'header_input' }
        },
        {
          title: '开单公司',
          field: 'saler_company_name',
          width: 200,
          slots: { header: 'header_input' }
        },
        {
          fixed: 'right',
          title: '是否已打印',
          field: 'is_print',
          width: 110,
          slots: { header: 'header_is_print', default: 'default_is_print' }
        },
        {
          fixed: 'right',
          title: '操作',
          field: 'operate',
          slots: { default: 'default_operate' },
          width: 73
        }
      ]
      this.$util.initTableColumnWidth(this.$options.tableName, result, 'inherit')
      return result
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    // 列宽变化，保存单列宽度
    handleColumnResize({ column }) {
      this.$util.setTableColumnWidth(this.$options.tableName, column.field, column.resizeWidth)
    },
    // 更新页面
    updatePage() {
      this.searchListData()
    },
    // 表头筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 重置表头筛选并刷新列表
    resetFilter() {
      this.resetFilterData()
      this.searchListData()
    },
    // 重置表头筛选
    resetFilterData() {
      Object.keys(this.filterData).forEach((key) => {
        this.filterData[key] = ''
      })
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      let params = {
        is_ming_xi: false,
        currentPage: this.pageOptions.currentPage,
        pageSize: this.pageOptions.pageSize,
        delivery_date: this.delivery_date || [],
        filterData: this.filterData,
        sortData: this.$util.deepCopy(this.sortData)
      }

      this.$api({
        method: 'post',
        url: '/admin/gcvip/songHuo4/list',
        data: params
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            let list = this.$util.deepCopy(data.list)
            list.forEach((item) => {
              item.isChuangJian = this.isAdmin || item.saler_id === this.accountId
              item.isFuZe = this.isAdmin || item.fu_ze_ren_id === this.accountId
            })
            this.tableData = list

            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber

            this.totalObj.goods_count_all = res.data.goods_count_all
            this.totalObj.goods_price_all = res.data.goods_price_all
            this.totalObj.goods_amount_all = res.data.goods_amount_all
            this.totalObj.song_huo_total_all = res.data.song_huo_total_all
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 获取-当前单选行
    getCheckboxRecords() {
      return this.$refs.refTable.getCheckboxRecords()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setCheckboxRow(params.row, true) // 选中checkbox
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowCheckbox = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isCurrentRowCheckbox) // 选中checkbox
      }
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 表格底部
    footerMethod({ columns }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (column.field === 'song_huo_count') return this.totalObj.goods_count_all
          if (column.field === 'goods_price') return this.totalObj.goods_price_all
          if (column.field === 'song_huo_amount') return this.totalObj.goods_amount_all
          if (column.field === 'song_huo_total') return this.totalObj.song_huo_total_all
        })
      ]
    },
    // 行类名计算，实现按字段分组的斑马纹效果
    cellClassName(rowData) {
      let result = this.$tool.getTableCellClassName(this.tableData, rowData, 'delivery_code')
      return result
    },
    // 项-增改-送货单
    itemDo(id = null) {
      this.activeId = id
      this.isShowPopupDo = true
    },
    // 项-双击增改
    itemDbDo(val) {
      this.itemDo(val.row.delivery_id)
    },
    // 项-打印
    itemPrint(id) {
      window.open(`/new/delivery/print?id=${id}`, '_blank')
    },
    // 状态标签样式：0草稿 1待审核 2已审核 3已作废（送货单以 delivery_status 为审核主依据）
    statusTagType(row) {
      if (row.status === 3) return 'info'
      if (row.status === 2 || row.delivery_status) return 'success'
      if (row.status === 1) return 'warning'
      return 'info'
    },
    isAudited(row) {
      return row.status === 2 || row.delivery_status === true
    },
    isCancelled(row) {
      return row.status === 3
    },
    canEdit(row) {
      return !this.isAudited(row) && !this.isCancelled(row)
    },
    canAudit(row) {
      return this.canEdit(row)
    },
    canUnaudit(row) {
      return this.isAudited(row)
    },
    // 项-审核
    itemPass(row) {
      this.$confirm(`确定审核送货单"${row.delivery_code}"吗?审核后将生成出库草稿并回写核算单进度。`, '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/songHuo4/changeStatus',
            params: { delivery_id: row.delivery_id, delivery_status: 'true' }
          })
            .then((res) => {
              this.handleActionRes(res, '审核成功')
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    // 项-反审核
    itemReject(row) {
      this.$confirm(`确定反审核送货单"${row.delivery_code}"吗?将回滚核算单送货进度并删除关联出库草稿。`, '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/songHuo4/changeStatus',
            params: { delivery_id: row.delivery_id, delivery_status: 'false' }
          })
            .then((res) => {
              this.handleActionRes(res, '反审核成功')
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    // 项-作废
    itemCancel(row) {
      this.$confirm(`确定作废送货单"${row.delivery_code}"吗?`, '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/songHuo4/cancel',
            params: { delivery_id: row.delivery_id }
          })
            .then((res) => {
              this.handleActionRes(res, '作废成功')
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    // 批量-审核
    batchPass() {
      this.$util.moduleLoading('审核')
    },
    // 批量-反审核
    batchReject() {
      this.$util.moduleLoading('反审核')
    },
    // 批量-删除
    batchDelete() {
      this.$util.moduleLoading('删除')
      // let rows = this.getCheckboxRecords()
      // if (rows.length) {
      //   this.isShowPopupBatch = true
      //   let ids = rows.map((item) => item.delivery_id)
      //   let codes = rows.map((item) => item.delivery_code)

      //   let obj = {
      //     ids: [...new Set(ids)],
      //     codes: [...new Set(codes)]
      //   }
      //   this.itemDelete(obj)
      // } else {
      //   this.itemChoosePrompt()
      // }
    },

    // 项-删除
    itemDelete(obj) {
      this.$confirm(`您确定要删除编码为"${obj.codes.join(',')}"的送货单吗?`, '提示')
        .then(() => {
          this.deleteConfirm(obj.ids)
        })
        .catch(() => {})
    },
    // 项-删除-确认
    deleteConfirm(ids) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/songHuo4/batch',
        params: {
          ids: ids.join(',')
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success('操作成功')
            this.getListData()
          }
        })
        .catch(() => {})
    },
    handleActionRes(res, okMsg) {
      if (res.data.state === 'ok') {
        this.$message.success(res.data.msg || okMsg)
        this.getListData()
      } else if (res.data.msg) {
        this.$message.error(res.data.msg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
// 是否已打印-表头筛选容器（参考采购申请列表实现）
.header-filter-box {
  color: @colorGrayDeep;
  .el-select {
    margin-top: 2px;
    /deep/ .el-input__inner {
      height: 24px;
      line-height: 24px;
      color: @colorGrayDeep;
      width: 100% !important;
      overflow: hidden;
      padding: 0 2px;
      text-align: center;
    }
    // 下拉箭头图标随输入框高度垂直居中
    /deep/ .el-input__icon {
      width: auto;
      line-height: 24px;
    }
    // 箭头区域白底，避免与居中文字重叠时透底
    /deep/ .el-input__suffix-inner {
      background: #fff;
    }
  }
}
</style>
